import { useContext } from 'react'
import { ReactNode } from 'react'

import { ToastContext } from '@/components/ui/toast/ToastProvider'
import { ToastOptions } from '@/components/ui/toast/types'

export function useToast() {
  const context = useContext(ToastContext)

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }

  const { showToast, removeToast, clearAllToasts } = context

  const showSuccessToast = (title: string, description?: string, options?: ToastOptions) => {
    return showToast({
      type: 'success',
      title,
      description,
      options,
    })
  }

  const showErrorToast = (title: string, description?: string, options?: ToastOptions) => {
    return showToast({
      type: 'error',
      title,
      description,
      options,
    })
  }

  const showWarningToast = (title: string, description?: string, options?: ToastOptions) => {
    return showToast({
      type: 'warning',
      title,
      description,
      options,
    })
  }

  const showInfoToast = (title: string, description?: string, options?: ToastOptions) => {
    return showToast({
      type: 'info',
      title,
      description,
      options,
    })
  }

  const showCustomToast = (component: ReactNode | ((close: () => void) => ReactNode), options?: ToastOptions) => {
    return showToast({
      type: 'custom',
      component,
      options,
    })
  }

  return {
    showToast,
    showSuccessToast,
    showErrorToast,
    showWarningToast,
    showInfoToast,
    showCustomToast,
    removeToast,
    clearAllToasts,
  }
}
